import { ReactHTML } from 'react';

export type ThemeTypographyVariants
  = | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'paragraph'
    | 'button'
    | 'label'
    | 'caption'
    | 'meta'
    | 'inherit';

export const ThemeTypographyVariantElementMap: Record<
  ThemeTypographyVariants,
  keyof ReactHTML
> = {
  button: 'span',
  caption: 'span',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  inherit: 'span',
  label: 'label',
  meta: 'span',
  paragraph: 'p',
};
